import React from 'react';

import StatisticheLicenze from './../containers/statistiche/StatisticheLicenze';


class Statistiche extends React.Component {    

    render() {
        return (
            <React.Fragment>
                <h2 className={'content-block'}>Statistiche Licenze</h2>

                <StatisticheLicenze />
                
            </React.Fragment>
        );
    }
};


export default Statistiche;